import React from "react";

const Section = props => {
	return (
		<div className="row p-0 m-0 justify-content-center">{props.children}</div>
	);
};
export default Section;
